import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  notifications: Array<any> = [];
  loading: Boolean = true;
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    this.apiservice.notificationSubject.subscribe(()=>{
      this.getNotifications();
    });
    this.getNotifications();
  }

  getNotifications() {
    this.apiservice.getAllN(this.apiservice.user._id).subscribe((res: any) => {
      this.loading = false;
      this.notifications = res.data;
    });
  }

  markAllAsRead() {
    this.apiservice.markAsReadN(this.apiservice.user._id).subscribe((res: any) => {
      this.apiservice.notificationSubject.next();
    });
  }

  deleteAllN() {
    this.apiservice.deleteAllN(this.apiservice.user._id).subscribe((res: any) => {
      this.apiservice.notificationSubject.next();
    });
  }

  checkForActive() {
    let active = this.notifications.filter(not => not.read == false);
    if (active.length > 0) {
      return true
    }
    return false;
  }

  formatTime(date) {
    return moment(date).format('MMM DD, YYYY hh:mm A');
  }

}
